/**
 * Custom Header JS
 * Handles: mega menu, mobile drawer, mobile search, desktop search, cart drawer, sticky behavior, variant buttons
 */
(function() {
  'use strict';

  /* ============================
     MEGA MENU (Desktop)
     ============================ */
  function initMegaMenus() {
    var triggers = document.querySelectorAll('[data-megamenu-trigger]');
    var menus = document.querySelectorAll('.custom-megamenu');
    var closeTimeout = null;

    function closeAll() {
      menus.forEach(function(m) { m.classList.remove('is-active'); });
      triggers.forEach(function(t) { t.classList.remove('is-active'); });
    }

    triggers.forEach(function(trigger) {
      var targetId = trigger.getAttribute('data-megamenu-trigger');
      var menu = document.getElementById(targetId);
      if (!menu) return;

      trigger.addEventListener('mouseenter', function() {
        clearTimeout(closeTimeout);
        closeAll();
        menu.classList.add('is-active');
        trigger.classList.add('is-active');
      });

      trigger.addEventListener('mouseleave', function() {
        closeTimeout = setTimeout(function() {
          if (!menu.matches(':hover')) {
            menu.classList.remove('is-active');
            trigger.classList.remove('is-active');
          }
        }, 150);
      });

      menu.addEventListener('mouseenter', function() {
        clearTimeout(closeTimeout);
      });

      menu.addEventListener('mouseleave', function() {
        closeTimeout = setTimeout(function() {
          menu.classList.remove('is-active');
          trigger.classList.remove('is-active');
        }, 150);
      });

      // Keyboard accessibility
      trigger.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var isActive = menu.classList.contains('is-active');
          closeAll();
          if (!isActive) {
            menu.classList.add('is-active');
            trigger.classList.add('is-active');
            var firstLink = menu.querySelector('a');
            if (firstLink) firstLink.focus();
          }
        }
        if (e.key === 'Escape') {
          closeAll();
          trigger.focus();
        }
      });
    });

    // Close on click outside
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.custom-megamenu') && !e.target.closest('[data-megamenu-trigger]')) {
        closeAll();
      }
    });

    // Close on Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  /* ============================
     MOBILE DRAWER
     ============================ */
  function initDrawer() {
    var drawer = document.getElementById('CustomDrawer');
    var overlay = document.getElementById('CustomDrawerOverlay');
    var openBtns = document.querySelectorAll('[data-custom-drawer-open]');
    var closeBtns = document.querySelectorAll('[data-custom-drawer-close]');

    if (!drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.classList.add('custom-drawer-open');
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.classList.remove('custom-drawer-open');
      // Close all submenus
      drawer.querySelectorAll('.custom-drawer__menu-item.is-open').forEach(function(item) {
        item.classList.remove('is-open');
      });
    }

    openBtns.forEach(function(btn) {
      btn.addEventListener('click', openDrawer);
    });

    closeBtns.forEach(function(btn) {
      btn.addEventListener('click', closeDrawer);
    });

    if (overlay) {
      overlay.addEventListener('click', closeDrawer);
    }

    // Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    // Submenu toggles
    var menuToggles = drawer.querySelectorAll('[data-drawer-submenu-toggle]');
    menuToggles.forEach(function(toggle) {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        var item = toggle.closest('.custom-drawer__menu-item');
        if (item) {
          item.classList.toggle('is-open');
        }
      });
    });
  }

  /* ============================
     MOBILE CART DRAWER INTEGRATION
     ============================ */
  function initMobileCartDrawer() {
    // Wire up ALL cart icon links to open the Horizon cart drawer instead of navigating
    var mobileCartLinks = document.querySelectorAll('[data-custom-cart-trigger]');
    var cartDrawer = document.querySelector('cart-drawer-component'); // Horizon theme element

    if (!cartDrawer) return; // cart_type != 'drawer' — plain <a> navigation is the right fallback

    mobileCartLinks.forEach(function(link) {
      link.setAttribute('role', 'button');
      link.setAttribute('aria-haspopup', 'dialog');
      link.addEventListener('click', function(e) {
        e.preventDefault();
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else if (typeof cartDrawer.showDialog === 'function') {
          cartDrawer.showDialog();
        } else {
          // Element not yet upgraded — open <dialog> natively with scroll lock
          var dlg = cartDrawer.querySelector('dialog');
          if (dlg && !dlg.open) {
            var sy = window.scrollY || window.pageYOffset || 0;
            document.body.style.width = '100%';
            document.body.style.position = 'fixed';
            document.body.style.top = '-' + sy + 'px';
            dlg.showModal();
            dlg.addEventListener('close', function() {
              document.body.style.width = '';
              document.body.style.position = '';
              document.body.style.top = '';
              window.scrollTo({ top: sy, behavior: 'instant' });
            }, { once: true });
          }
        }
      });
    });
  }

  /* ============================
     MOBILE DRAWER SEARCH (Predictive)
     ============================ */
  function initDrawerSearch() {
    var input = document.getElementById('CustomDrawerSearchInput');
    var resultsContainer = document.getElementById('CustomDrawerSearchResults');
    if (!input || !resultsContainer) return;

    var debounceTimer = null;
    var abortController = null;

    input.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      var query = input.value.trim();

      if (query.length < 2) {
        resultsContainer.innerHTML = '';
        resultsContainer.classList.remove('has-results');
        return;
      }

      debounceTimer = setTimeout(function() {
        fetchResults(query);
      }, 300);
    });

    function fetchResults(query) {
      if (abortController) abortController.abort();
      abortController = new AbortController();

      var url = window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root + 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last'
        : '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';

      fetch(url, { signal: abortController.signal })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          renderResults(data, query);
        })
        .catch(function(err) {
          if (err.name !== 'AbortError') console.error(err);
        });
    }

    function renderResults(data, query) {
      var products = data.resources && data.resources.results && data.resources.results.products
        ? data.resources.results.products
        : [];

      if (products.length === 0) {
        resultsContainer.innerHTML = '<div style="padding:14px 16px;font-size:13px;opacity:0.6;">No results found</div>';
        resultsContainer.classList.add('has-results');
        return;
      }

      var html = '';
      products.forEach(function(product) {
        var imgSrc = product.image ? product.image : '';
        var price = product.price ? formatMoney(product.price) : '';
        html += '<a href="' + product.url + '" class="search-result-item">';
        if (imgSrc) {
          html += '<img src="' + imgSrc + '" alt="' + escapeHtml(product.title) + '" loading="lazy">';
        }
        html += '<div class="search-result-item__info">';
        html += '<span class="search-result-item__title">' + escapeHtml(product.title) + '</span>';
        if (price) {
          html += '<span class="search-result-item__price">' + price + '</span>';
        }
        html += '</div></a>';
      });

      // View all link
      var searchUrl = '/search?q=' + encodeURIComponent(query);
      html += '<a href="' + searchUrl + '" class="search-result-item" style="justify-content:center;font-size:13px;font-weight:600;padding:12px;">View all results</a>';

      resultsContainer.innerHTML = html;
      resultsContainer.classList.add('has-results');
    }

    function formatMoney(cents) {
      if (typeof cents === 'string') cents = parseFloat(cents);
      var amount = parseFloat(cents);
      if (isNaN(amount)) return '';
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        return window.Shopify.currency.active + ' ' + amount.toFixed(2);
      }
      return '$' + amount.toFixed(2);
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }
  }

  /* ============================
     DESKTOP SEARCH (Jalmira-style predictive)
     ============================ */
  function initDesktopSearch() {
    // Grab ALL search toggles (desktop + mobile share the class)
    var searchToggles = document.querySelectorAll('[data-custom-search-toggle]');
    var searchContainer = document.getElementById('CustomSearchContainer');
    var searchInput = document.getElementById('CustomDesktopSearchInput');
    var searchResults = document.getElementById('CustomDesktopSearchResults');
    var searchClose = document.getElementById('CustomSearchClose');
    var searchScreen = document.getElementById('CustomSearchScreen');

    if (!searchContainer || searchToggles.length === 0) return;

    var debounceTimer = null;
    var abortController = null;

    searchToggles.forEach(function(toggle) {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        openSearch();
      });
    });

    function openSearch() {
      // Position search bar just below the header
      var sectionEl = searchContainer.closest('.custom-header-section');
      var headerWrapper = sectionEl ? sectionEl.querySelector('.custom-header-wrapper') : null;
      if (headerWrapper) {
        var headerRect = headerWrapper.getBoundingClientRect();
        searchContainer.style.paddingTop = headerRect.bottom + 'px';
      }
      searchContainer.classList.add('is-active');
      document.body.classList.add('custom-search-open');
      if (searchInput) {
        setTimeout(function() { searchInput.focus(); }, 100);
      }
    }

    function closeSearch() {
      searchContainer.classList.remove('is-active');
      document.body.classList.remove('custom-search-open');
      if (searchResults) {
        searchResults.innerHTML = '';
        searchResults.style.display = 'none';
      }
      if (searchInput) searchInput.value = '';
    }

    if (searchClose) searchClose.addEventListener('click', closeSearch);
    if (searchScreen) searchScreen.addEventListener('click', closeSearch);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && searchContainer.classList.contains('is-active')) {
        closeSearch();
      }
    });

    if (searchInput) {
      searchInput.addEventListener('input', function() {
        clearTimeout(debounceTimer);
        var query = searchInput.value.trim();
        if (query.length < 2) {
          if (searchResults) {
            searchResults.innerHTML = '';
            searchResults.style.display = 'none';
          }
          return;
        }
        debounceTimer = setTimeout(function() {
          fetchDesktopResults(query);
        }, 300);
      });
    }

    function fetchDesktopResults(query) {
      if (abortController) abortController.abort();
      abortController = new AbortController();

      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      var url = rootUrl + 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,query,collection,page&resources[limit]=4&resources[options][unavailable_products]=last';

      fetch(url, { signal: abortController.signal })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          renderDesktopResults(data, query);
        })
        .catch(function(err) {
          if (err.name !== 'AbortError') console.error(err);
        });
    }

    function renderDesktopResults(data, query) {
      if (!searchResults) return;
      var resources = data.resources && data.resources.results ? data.resources.results : {};
      var products = resources.products || [];
      var queries = resources.queries || [];
      var collections = resources.collections || [];
      var pages = resources.pages || [];

      var totalCount = products.length + queries.length + collections.length + pages.length;

      if (totalCount === 0) {
        searchResults.innerHTML = '<div style="padding:20px;text-align:center;font-size:14px;opacity:0.6;">No results found for &ldquo;' + escapeHtml(query) + '&rdquo;</div>';
        searchResults.style.display = 'block';
        return;
      }

      var html = '<div class="custom-search-results__inner">';

      var leftHasContent = queries.length > 0 || collections.length > 0 || pages.length > 0;
      if (leftHasContent) {
        html += '<div class="custom-search-results__left">';
        if (queries.length > 0) {
          html += '<div class="custom-search-results__group"><h4 class="custom-search-results__group-title">Suggestions</h4><ul>';
          queries.forEach(function(q) {
            html += '<li><a href="/search?q=' + encodeURIComponent(q.text) + '">' + q.styled_text + '</a></li>';
          });
          html += '</ul></div>';
        }
        if (collections.length > 0) {
          html += '<div class="custom-search-results__group"><h4 class="custom-search-results__group-title">Collections</h4><ul>';
          collections.forEach(function(c) {
            html += '<li><a href="' + c.url + '">' + escapeHtml(c.title) + '</a></li>';
          });
          html += '</ul></div>';
        }
        if (pages.length > 0) {
          html += '<div class="custom-search-results__group"><h4 class="custom-search-results__group-title">Pages</h4><ul>';
          pages.forEach(function(p) {
            html += '<li><a href="' + p.url + '">' + escapeHtml(p.title) + '</a></li>';
          });
          html += '</ul></div>';
        }
        html += '</div>';
      }

      if (products.length > 0) {
        html += '<div class="custom-search-results__right"><h4 class="custom-search-results__group-title">Products</h4><ul>';
        products.forEach(function(p) {
          var imgSrc = p.image ? p.image : '';
          var price = p.price ? formatMoney(p.price) : '';
          html += '<li><a href="' + p.url + '" class="custom-search-product">';
          if (imgSrc) {
            html += '<img src="' + imgSrc + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="80" height="80">';
          }
          html += '<div class="custom-search-product__info"><span class="custom-search-product__title">' + escapeHtml(p.title) + '</span>';
          if (price) html += '<span class="custom-search-product__price">' + price + '</span>';
          html += '</div></a></li>';
        });
        html += '</ul></div>';
      }

      html += '</div>';
      html += '<a href="/search?q=' + encodeURIComponent(query) + '" class="custom-search-results__view-all">View all results <svg width="14" height="10" viewBox="0 0 14 10" fill="none"><path d="M0 5H12.5M12.5 5L8.5 1M12.5 5L8.5 9" stroke="currentColor"/></svg></a>';

      searchResults.innerHTML = html;
      searchResults.style.display = 'block';
    }

    function formatMoney(cents) {
      var amount = parseFloat(cents);
      if (isNaN(amount)) return '';
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        return window.Shopify.currency.active + ' ' + amount.toFixed(2);
      }
      return '$' + amount.toFixed(2);
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str || '';
      return div.innerHTML;
    }
  }

  /* ============================
     DRAWER PRODUCT VARIANT BUTTONS
     ============================ */
  function initDrawerVariantButtons() {
    var drawer = document.getElementById('CustomDrawer');
    if (!drawer) return;

    drawer.addEventListener('click', function(e) {
      var btn = e.target.closest('.custom-drawer__variant-btn');
      if (!btn) return;

      // Prevent the parent <a> link from navigating
      e.preventDefault();
      e.stopPropagation();

      var card = btn.closest('.custom-drawer__product-card');
      if (!card) return;

      // Remove active from siblings
      card.querySelectorAll('.custom-drawer__variant-btn').forEach(function(b) {
        b.classList.remove('active');
      });
      btn.classList.add('active');

      // Update image
      var imgUrl = btn.getAttribute('data-variant-image');
      if (imgUrl) {
        var img = card.querySelector('.custom-drawer__product-card__image img');
        if (img) img.src = imgUrl;
      }

      // Update price
      var priceEl = card.querySelector('.custom-drawer__product-card__price');
      if (priceEl) {
        var price = btn.getAttribute('data-variant-price');
        var comparePrice = btn.getAttribute('data-variant-compare-price');
        var html = '';
        if (comparePrice) {
          html += '<span class="compare-price">' + comparePrice + '</span>';
        }
        html += '<span>' + (price || '') + '</span>';
        priceEl.innerHTML = html;
      }

      // Update product URL
      var productUrl = btn.getAttribute('data-product-url');
      var variantId = btn.getAttribute('data-variant-id');
      var link = card.querySelector('a');
      if (link && productUrl && variantId) {
        link.href = productUrl + '?variant=' + variantId;
      }
    });
  }

  /* ============================
     STICKY HEADER
     ============================ */
  function initStickyHeader() {
    var headerWrapper = document.querySelector('.custom-header-wrapper');
    if (!headerWrapper) return;
    var stickyType = headerWrapper.getAttribute('data-sticky-type');

    // Target the Shopify section wrapper (parent of .custom-header-section)
    var sectionEl = headerWrapper.closest('.shopify-section');
    if (!sectionEl) return;

    if (stickyType === 'none') {
      sectionEl.classList.add('sticky-none');
      return;
    }

    if (stickyType === 'always') {
      // CSS handles sticky via .section-header.shopify-section
      return;
    }

    // on-scroll-up behavior
    var lastScrollY = 0;
    var headerHeight = sectionEl.offsetHeight;

    window.addEventListener('scroll', function() {
      var currentScrollY = window.pageYOffset || document.documentElement.scrollTop;

      if (currentScrollY > lastScrollY && currentScrollY > headerHeight) {
        sectionEl.classList.add('is-hidden');
      } else {
        sectionEl.classList.remove('is-hidden');
      }
      lastScrollY = currentScrollY;
    }, { passive: true });
  }

  /* ============================
     POSITION DRAWER BELOW ANNOUNCEMENT BAR
     ============================ */
  function positionDrawer() {
    var drawer = document.getElementById('CustomDrawer');
    if (!drawer) return;

    // Drawer always covers full screen from top: 0
    drawer.style.top = '0';
    drawer.style.height = '100%';
  }

  /* ============================
     INIT
     ============================ */
  function init() {
    initMegaMenus();
    initDrawer();
    initMobileCartDrawer();
    initDrawerSearch();
    initDesktopSearch();
    initDrawerVariantButtons();
    initStickyHeader();
    positionDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
